import { render } from "./iconTrash.vue?vue&type=template&id=373e0e5c"
import script from "./iconTrash.vue?vue&type=script&lang=js"
export * from "./iconTrash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__